import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_pos-r" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_text_field = _resolveComponent("text-field")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.hasIcon)
      ? (_openBlock(), _createBlock(_component_base_icon, {
          key: 0,
          name: "search",
          class: "_ha-left _px-2"
        }))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_text_field, {
      class: "_mt-3 _mb-2",
      "model-value": $props.modelValue,
      placeholder: _ctx.Resources.Common.SearchFieldPlaceholder,
      "has-icon": $options.hasIcon,
      "onUpdate:modelValue": $options.onInput
    }, null, 8 /* PROPS */, ["model-value", "placeholder", "has-icon", "onUpdate:modelValue"]),
    _withDirectives(_createElementVNode("button", {
      class: "_ha-right _tc--accent gfu-btn",
      onMousedown: _cache[0] || (_cache[0] = (...args) => ($options.clearInput && $options.clearInput(...args))),
      "data-qa": "search-field:ClearInput"
    }, [
      _createVNode(_component_base_icon, { name: "times" })
    ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
      [_vShow, $props.modelValue]
    ])
  ]))
}